import { Injectable, Injector } from '@angular/core';
import { BeneficiaireService } from './beneficiaire/beneficiaire.service';
import { MissionPlaceService } from './mission-place/mission-place.service';
import { FormationService } from './formation/formation.service';
import { EmployeeService } from './employee/employee.service';
import { DataStorageService } from './dataStorage/data-storage.service';
import { MessageService } from './message/message.service';
import { MissionService } from './mission/mission.service';
import { NominatimService } from './nominatim/nominatim.service';
import { PlanningService } from './planning/planning.service';
import { SolutionService } from './solution/solution.service';
import { SpecialiteService } from './specialite/specialite.service';
import { StatistiqueService } from './statistique/statistique.service';
import { ToastService } from './toast/toast.service';
import { VacationTypeService } from './vacation-type/vacation-type.service';
import { UserService } from './user/user.service';
import { VehiculeService } from './vehicule/vehicule.service';
import { AuthenticationService } from './authentication/authentication.service';
import { NotificationService } from './notificaton/notification.service';
import { VacationService } from './vacation/vacation.service';
import { UnavailabilityService } from './unavailability/unavailability.service';
import { CenterService } from './center/center.service';
import { MobileService } from './mobile/mobile.service';
import { RouteService } from './route/route.service';
import { AreaService } from './area/area.service';
import { MissionTypeService } from './mission-type/mission-type.service';
import { CacheService } from './cache/cache.service';
import { ExportService } from './export/export.service';
import { FunderService } from './funder/funder.service';
import { AvailabilityService } from './availability/availability.service';
import { MeetingService } from './meeting/meeting.service';
import { ProfileService } from './profile/profile.service';
import { PermissionService } from './permission/permission.service';
import { TauxReconnaissanceService } from './tauxReconnaissance/tauxReconnaissance.service';
import { NiveauEtudeService } from './niveauEtude/niveauEtude.service';
import { NiveauQualificationService } from './niveauQualification/niveauQualification.service';
import { TypeStructureService } from './typeStructure/typeStructure.service';
import { ModaliteReunionService } from './modaliteReunion/modaliteReunion.service';
import { OrigineDemandeService } from './origineDemande/origineDemande.service';
import { ObjectifProService } from './objectifPro/objectifPro.service';
import { AmenagementService } from './amenagement/amenagement.service';
import { NotificationEmailService } from './notificationEmail/notificationEmail.service';
import { ExpertiseService } from './expertise/expertise.service';
import { SituationService } from './situation/situation.service';
import { PrestationService } from './prestation/prestation.service';
import { PrescripteurService } from './prescripteur/prescripteur.service';
import { QualificationService } from './qualification/qualification.service';
import { CapaciteService } from './capacite/capacite.service';
import { SituationPrestationService } from './situationPrestation/situationPrestation.service';
import { TypeEntretienService } from './typeEntretien/typeEntretien.service';
import { SuiviPrestationService } from './suiviPrestation/suiviPrestation.service';
import { TacheService } from './tache/tache.service';
import { ActivitePrestationService } from './activitePrestation/activitePrestation.service';
import { InstitutionService } from './institution/institution.service';
import { TypeFormationService } from './typeFormation/typeFormation.service';
import { RegionService } from './region/region.service';
import { DepartementService } from './departement/departement.service';
import { ServiceService } from './service/service.service';
import { InfosasService } from './infosas/infosas.service';
import { CanalCommunicationService } from './canalCommunication/canalCommunication.service';
import { TypeHandicapService } from './typeHandicap/typeHandicap.service';
import { StatutProfessionnelService } from './statutProfessionnel/statutProfessionnel.service';
import { EligibiliteBeneficiaireService } from './eligibiliteBeneficiaire/eligibiliteBeneficiaire.service';
import { EvaluationService } from './evaluation/evaluation.service';
import { PrestationFichierService } from './prestationFichier/prestationFichier.service';
import { TypeDocumentService } from './typeDocument/typeDocument.service';
import { SuiviPrecoService } from './suiviPreco/suiviPreco.service';
import { BonCommandeService } from './bonCommande/bonCommande.service';
import { SituationFamilialeService } from './situationFamiliale/situationFamiliale.service';
import { TypeEntrepriseService } from './typeEntreprise/typeEntreprise.service';
import { EmployeurService } from './employeur/employeur.service';
import { BonCommandeReferenceService } from './bonCommandeReference/bonCommandeReference.service';
import { RestitutionPrestationService } from './restitutionPrestation/restitutionPrestation.service';
import { MiseEnOeuvreEmploiService } from './miseEnOeuvreEmploi/miseEnOeuvreEmploi.service';

@Injectable({
	providedIn: 'root'
})
export class FacadeService {
	private _beneficiaireService: BeneficiaireService;
	public get beneficiaireService(): BeneficiaireService {
		if (!this._beneficiaireService) {
			this._beneficiaireService = this.injector.get(BeneficiaireService);
		}
		return this._beneficiaireService;
	}

	private _prescripteurService: PrescripteurService;
	public get prescripteurService(): PrescripteurService {
		if (!this._prescripteurService) {
			this._prescripteurService = this.injector.get(PrescripteurService);
		}
		return this._prescripteurService;
	}

	private _employeurService: EmployeurService;
	public get employeurService(): EmployeurService {
		if (!this._employeurService) {
			this._employeurService = this.injector.get(EmployeurService);
		}
		return this._employeurService;
	}


	private _missionPlaceService: MissionPlaceService;
	public get missionPlaceService(): MissionPlaceService {
		if (!this._missionPlaceService) {
			this._missionPlaceService = this.injector.get(MissionPlaceService);
		}
		return this._missionPlaceService;
	}

	private _formationService: FormationService;
	public get formationService(): FormationService {
		if (!this._formationService) {
			this._formationService = this.injector.get(FormationService);
		}
		return this._formationService;
	}

	private _employeeService: EmployeeService;
	public get employeeService(): EmployeeService {
		if (!this._employeeService) {
			this._employeeService = this.injector.get(EmployeeService);
		}
		return this._employeeService;
	}

	private _prestationService: PrestationService;
	public get prestationService(): PrestationService {
		if (!this._prestationService) {
			this._prestationService = this.injector.get(PrestationService);
		}
		return this._prestationService;
	}

	private _qualificationService: QualificationService;
	public get qualificationService(): QualificationService {
		if (!this._qualificationService) {
			this._qualificationService = this.injector.get(QualificationService);
		}
		return this._qualificationService;
	}

	private _capaciteService: CapaciteService;
	public get capaciteService(): CapaciteService {
		if (!this._capaciteService) {
			this._capaciteService = this.injector.get(CapaciteService);
		}
		return this._capaciteService;
	}

	private _situationPrestationService: SituationPrestationService;
	public get situationPrestationService(): SituationPrestationService {
		if (!this._situationPrestationService) {
			this._situationPrestationService = this.injector.get(SituationPrestationService);
		}
		return this._situationPrestationService;
	}

	private _evaluationService: EvaluationService;
	public get evaluationService(): EvaluationService {
		if (!this._evaluationService) {
			this._evaluationService = this.injector.get(EvaluationService);
		}
		return this._evaluationService;
	}

	private _suiviPrecoService: SuiviPrecoService;
	public get suiviPrecoService(): SuiviPrecoService {
		if (!this._suiviPrecoService) {
			this._suiviPrecoService = this.injector.get(SuiviPrecoService);
		}
		return this._suiviPrecoService;
	}

	private _miseEnOeuvreEmploiService: MiseEnOeuvreEmploiService;
	public get miseEnOeuvreEmploiService(): MiseEnOeuvreEmploiService {
		if (!this._miseEnOeuvreEmploiService) {
			this._miseEnOeuvreEmploiService = this.injector.get(MiseEnOeuvreEmploiService);
		}
		return this._miseEnOeuvreEmploiService;
	}

	private _infosasService: InfosasService;
	public get infosasService(): InfosasService {
		if (!this._infosasService) {
			this._infosasService = this.injector.get(InfosasService);
		}
		return this._infosasService;
	}


	private _dataStorageService: DataStorageService;
	public get dataStorageService(): DataStorageService {
		if (!this._dataStorageService) {
			this._dataStorageService = this.injector.get(DataStorageService);
		}
		return this._dataStorageService;
	}

	private _missionService: MissionService;
	public get missionService(): MissionService {
		if (!this._missionService) {
			this._missionService = this.injector.get(MissionService);
		}
		return this._missionService;
	}

	private _nominatimService: NominatimService;
	public get nominatimService(): NominatimService {
		if (!this._nominatimService) {
			this._nominatimService = this.injector.get(NominatimService);
		}
		return this._nominatimService;
	}

	private _planningService: PlanningService;
	public get planningService(): PlanningService {
		if (!this._planningService) {
			this._planningService = this.injector.get(PlanningService);
		}
		return this._planningService;
	}

	private _profileService: ProfileService;
	public get profileService(): ProfileService {
		if (!this._profileService) {
			this._profileService = this.injector.get(ProfileService);
		}
		return this._profileService;
	}

	private _permissionService: PermissionService;
	public get permissionService(): PermissionService {
		if (!this._permissionService) {
			this._permissionService = this.injector.get(PermissionService);
		}
		return this._permissionService;
	}

	private _specialiteService: SpecialiteService;
	public get specialiteService(): SpecialiteService {
		if (!this._specialiteService) {
			this._specialiteService = this.injector.get(SpecialiteService);
		}
		return this._specialiteService;
	}

	private _expertiseService: ExpertiseService;
	public get expertiseService(): ExpertiseService {
		if (!this._expertiseService) {
			this._expertiseService = this.injector.get(ExpertiseService);
		}
		return this._expertiseService;
	}

	private _typeHandicapService: TypeHandicapService;
	public get typeHandicapService(): TypeHandicapService {
		if (!this._typeHandicapService) {
			this._typeHandicapService = this.injector.get(TypeHandicapService);
		}
		return this._typeHandicapService;
	}

	private _tauxReconnaissanceService: TauxReconnaissanceService;
	public get tauxReconnaissanceService(): TauxReconnaissanceService {
		if (!this._tauxReconnaissanceService) {
			this._tauxReconnaissanceService = this.injector.get(TauxReconnaissanceService);
		}
		return this._tauxReconnaissanceService;
	}

	private _niveauEtudeService: NiveauEtudeService;
	public get niveauEtudeService(): NiveauEtudeService {
		if (!this._niveauEtudeService) {
			this._niveauEtudeService = this.injector.get(NiveauEtudeService);
		}
		return this._niveauEtudeService;
	}

	private _niveauQualificationService: NiveauQualificationService;
	public get niveauQualificationService(): NiveauQualificationService {
		if (!this._niveauQualificationService) {
			this._niveauQualificationService = this.injector.get(NiveauQualificationService);
		}
		return this._niveauQualificationService;
	}

	private _typeStructureService: TypeStructureService;
	public get typeStructureService(): TypeStructureService {
		if (!this._typeStructureService) {
			this._typeStructureService = this.injector.get(TypeStructureService);
		}
		return this._typeStructureService;
	}

	private _typeEntrepriseService: TypeEntrepriseService;
	public get typeEntrepriseService(): TypeEntrepriseService {
		if (!this._typeEntrepriseService) {
			this._typeEntrepriseService = this.injector.get(TypeEntrepriseService);
		}
		return this._typeEntrepriseService;
	}
	
	private _typeFormationService: TypeFormationService;
	public get typeFormationService(): TypeFormationService {
		if (!this._typeStructureService) {
			this._typeFormationService = this.injector.get(TypeFormationService);
		}
		return this._typeFormationService;
	}

	private _typeEntretienService: TypeEntretienService;
	public get typeEntretienService(): TypeEntretienService {
		if (!this._typeEntretienService) {
			this._typeEntretienService = this.injector.get(TypeEntretienService);
		}
		return this._typeEntretienService;
	}

	private _typeDocumentService: TypeDocumentService;
	public get typeDocumentService(): TypeDocumentService {
		if (!this._typeDocumentService) {
			this._typeDocumentService = this.injector.get(TypeDocumentService);
		}
		return this._typeDocumentService;
	}

	private _modaliteReunionService: ModaliteReunionService;
	public get modaliteReunionService(): ModaliteReunionService {
		if (!this._modaliteReunionService) {
			this._modaliteReunionService = this.injector.get(ModaliteReunionService);
		}
		return this._modaliteReunionService;
	}

	private _origineDemandeService: OrigineDemandeService;
	public get origineDemandeService(): OrigineDemandeService {
		if (!this._origineDemandeService) {
			this._origineDemandeService = this.injector.get(OrigineDemandeService);
		}
		return this._origineDemandeService;
	}

	private _objectifProService: ObjectifProService;
	public get objectifProService(): ObjectifProService {
		if (!this._objectifProService) {
			this._objectifProService = this.injector.get(ObjectifProService);
		}
		return this._objectifProService;
	}

	private _amenagementService: AmenagementService;
	public get amenagementService(): AmenagementService {
		if (!this._amenagementService) {
			this._amenagementService = this.injector.get(AmenagementService);
		}
		return this._amenagementService;
	}

	private _situationFamilialeService: SituationFamilialeService;
	public get situationFamilialeService(): SituationFamilialeService {
		if (!this._situationFamilialeService) {
			this._situationFamilialeService = this.injector.get(SituationFamilialeService);
		}
		return this._situationFamilialeService;
	}

	private _statutProfessionnelService: StatutProfessionnelService;
	public get statutProfessionnelService(): StatutProfessionnelService {
		if (!this._statutProfessionnelService) {
			this._statutProfessionnelService = this.injector.get(StatutProfessionnelService);
		}
		return this._statutProfessionnelService;
	}

	private _eligibiliteBeneficiaireService: EligibiliteBeneficiaireService;
	public get eligibiliteBeneficiaireService(): EligibiliteBeneficiaireService {
		if (!this._eligibiliteBeneficiaireService) {
			this._eligibiliteBeneficiaireService = this.injector.get(EligibiliteBeneficiaireService);
		}
		return this._eligibiliteBeneficiaireService;
	}

	private _canalCommunicationService: CanalCommunicationService;
	public get canalCommunicationService(): CanalCommunicationService {
		if (!this._canalCommunicationService) {
			this._canalCommunicationService = this.injector.get(CanalCommunicationService);
		}
		return this._canalCommunicationService;
	}

	private _regionService: RegionService;
	public get regionService(): RegionService {
		if (!this._regionService) {
			this._regionService = this.injector.get(RegionService);
		}
		return this._regionService;
	}

	private _departementService: DepartementService;
	public get departementService(): DepartementService {
		if (!this._departementService) {
			this._departementService = this.injector.get(DepartementService);
		}
		return this._departementService;
	}

	private _serviceService: ServiceService;
	public get serviceService(): ServiceService {
		if (!this._serviceService) {
			this._serviceService = this.injector.get(ServiceService);
		}
		return this._serviceService;
	}

	private _tacheService: TacheService;
	public get tacheService(): TacheService {
		if (!this._tacheService) {
			this._tacheService = this.injector.get(TacheService);
		}
		return this._tacheService;
	}

	private _situationService: SituationService;
	public get situationService(): SituationService {
		if (!this._situationService) {
			this._situationService = this.injector.get(SituationService);
		}
		return this._situationService;
	}

	private _notificationEmailService: NotificationEmailService;
	public get notificationEmailService(): NotificationEmailService {
		if (!this._notificationEmailService) {
			this._notificationEmailService = this.injector.get(NotificationEmailService);
		}
		return this._notificationEmailService;
	}

	private _statistiqueService: StatistiqueService;
	public get statistiqueService(): StatistiqueService {
		if (!this._statistiqueService) {
			this._statistiqueService = this.injector.get(StatistiqueService);
		}
		return this._statistiqueService;
	}

	private _vacationTypeService: VacationTypeService;
	public get vacationTypeService(): VacationTypeService {
		if (!this._vacationTypeService) {
			this._vacationTypeService = this.injector.get(VacationTypeService);
		}
		return this._vacationTypeService;
	}

	private _userService: UserService;
	public get userService(): UserService {
		if (!this._userService) {
			this._userService = this.injector.get(UserService);
		}
		return this._userService;
	}

	private _toastService: ToastService;
	public get toastService(): ToastService {
		if (!this._toastService) {
			this._toastService = this.injector.get(ToastService);
		}
		return this._toastService;
	}

	private _vehiculeService: VehiculeService;
	public get vehiculeService(): VehiculeService {
		if (!this._vehiculeService) {
			this._vehiculeService = this.injector.get(VehiculeService);
		}
		return this._vehiculeService;
	}

	private _solutionService: SolutionService;
	public get solutionService(): SolutionService {
		if (!this._solutionService) {
			this._solutionService = this.injector.get(SolutionService);
		}
		return this._solutionService;
	}

	private _authenticationService: AuthenticationService;
	public get authenticationService(): AuthenticationService {
		if (!this._authenticationService) {
			this._authenticationService = this.injector.get(AuthenticationService);
		}
		return this._authenticationService;
	}
	private _MessageService: MessageService;
	public get messageService(): MessageService {
		if (!this._MessageService) {
			this._MessageService = this.injector.get(MessageService);
		}
		return this._MessageService;
	}

	// private _NotificationService: NotificationService;
	// public get notificationService(): NotificationService {
	// 	if (!this._NotificationService) {
	// 		this._NotificationService = this.injector.get(NotificationService);
	// 	}
	// 	return this._NotificationService;
	// }

	private _VacationService: VacationService;
	public get vacationService(): VacationService {
		if (!this._VacationService) {
			this._VacationService = this.injector.get(VacationService);
		}
		return this._VacationService;
	}

	private _UnavailabilityService: UnavailabilityService;
	public get unavailabilityService(): UnavailabilityService {
		if (!this._UnavailabilityService) {
			this._UnavailabilityService = this.injector.get(UnavailabilityService);
		}
		return this._UnavailabilityService;
	}

	private _CenterService: CenterService;
	public get centerService(): CenterService {
		if (!this._CenterService) {
			this._CenterService = this.injector.get(CenterService);
		}
		return this._CenterService;
	}

	private _MobileService: MobileService;
	public get mobileService(): MobileService {
		if (!this._MobileService) {
			this._MobileService = this.injector.get(MobileService);
		}
		return this._MobileService;
	}

	private _RouteService: RouteService;
	public get routeService(): RouteService {
		if (!this._RouteService) {
			this._RouteService = this.injector.get(RouteService);
		}
		return this._RouteService;
	}

	private _ExportService: ExportService;
	public get exportService(): ExportService {
		if (!this._ExportService) {
			this._ExportService = this.injector.get(ExportService);
		}
		return this._ExportService;
	}

	private _AreaService: AreaService;
	public get areaService(): AreaService {
		if (!this._AreaService) {
			this._AreaService = this.injector.get(AreaService);
		}
		return this._AreaService;
	}

	private _MissionTypeService: MissionTypeService;
	public get missionTypeService(): MissionTypeService {
		if (!this._MissionTypeService) {
			this._MissionTypeService = this.injector.get(MissionTypeService);
		}
		return this._MissionTypeService;
	}

	private _CacheService: CacheService;
	public get cacheService(): CacheService {
		if (!this._CacheService) {
			this._CacheService = this.injector.get(CacheService);
		}
		return this._CacheService;
	}

	private _AvailabilityService: AvailabilityService;
	public get availabilityService(): AvailabilityService {
		if (!this._AvailabilityService) {
			this._AvailabilityService = this.injector.get(AvailabilityService);
		}
		return this._AvailabilityService;
	}

	private _FunderService: FunderService;
	public get funderService(): FunderService {
		if (!this._FunderService) {
			this._FunderService = this.injector.get(FunderService);
		}
		return this._FunderService;
	}

	private _MeetingService: MeetingService;
	public get meetingService(): MeetingService {
		if (!this._MeetingService) {
			this._MeetingService = this.injector.get(MeetingService);
		}
		return this._MeetingService;
	}

	private _suiviPrestationService: SuiviPrestationService;
	public get suiviPrestationService(): SuiviPrestationService {
		if (!this._suiviPrestationService) {
			this._suiviPrestationService = this.injector.get(SuiviPrestationService);
		}
		return this._suiviPrestationService;
	}

	private _prestationFichierService: PrestationFichierService;
	public get prestationFichierService(): PrestationFichierService {
		if (!this._prestationFichierService) {
			this._prestationFichierService = this.injector.get(PrestationFichierService);
		}
		return this._prestationFichierService;
	}

	private _activitePrestationService: ActivitePrestationService;
	public get activitePrestationService(): ActivitePrestationService {
		if (!this._activitePrestationService) {
			this._activitePrestationService = this.injector.get(ActivitePrestationService);
		}
		return this._activitePrestationService;
	}

	private _restitutionPrestationService: RestitutionPrestationService;
	public get restitutionPrestationService(): RestitutionPrestationService {
		if (!this._restitutionPrestationService) {
			this._restitutionPrestationService = this.injector.get(RestitutionPrestationService);
		}
		return this._restitutionPrestationService;
	}

	private _institutionService: InstitutionService;
	public get institutionService(): InstitutionService {
		if (!this._institutionService) {
			this._institutionService = this.injector.get(InstitutionService);
		}
		return this._institutionService;
	}

	private _bonCommandeService: BonCommandeService;
	public get bonCommandeService(): BonCommandeService {
		if (!this._bonCommandeService) {
			this._bonCommandeService = this.injector.get(BonCommandeService);
		}
		return this._bonCommandeService;
	}

	private _bonCommandeReferenceService: BonCommandeReferenceService;
	public get bonCommandeReferenceService(): BonCommandeReferenceService {
		if (!this._bonCommandeReferenceService) {
			this._bonCommandeReferenceService = this.injector.get(BonCommandeReferenceService);
		}
		return this._bonCommandeReferenceService;
	}

	constructor(private injector: Injector) {}
}
